export default __webpack_public_path__ + "static/media/online-shop-ads.54446478.png";